"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDefined = function (val) { return val != null; };
exports.isFunction = function (val) { return typeof val === 'function'; };
exports.noop = function (_) { };
exports.newScript = function (src) { return function (cb) {
    var scriptElem = document.createElement('script');
    var resultSrc = src;
    if (typeof resultSrc === 'object') {
        // copy every property to the element
        for (var key in resultSrc) {
            if (Object.prototype.hasOwnProperty.call(resultSrc, key)) {
                scriptElem[key] = resultSrc[key];
            }
        }
        resultSrc = resultSrc.src;
    }
    else {
        scriptElem.src = resultSrc;
    }
    scriptElem.addEventListener('load', function () { return cb(null, resultSrc); });
    scriptElem.addEventListener('error', function () { return cb(true, resultSrc); });
    document.body.appendChild(scriptElem);
    return scriptElem;
}; };
var keyIterator = function (cols) {
    var keys = Object.keys(cols);
    var i = -1;
    return {
        next: function () {
            i = i + 1;
            if (i >= keys.length)
                return null;
            return keys[i];
        },
    };
};
// tasks should be a collection of thunk
exports.parallel = function () {
    var tasks = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        tasks[_i] = arguments[_i];
    }
    return function (each) { return function (cb) {
        var hasError = false;
        var successed = 0;
        var ret = [];
        var filteredTasks = tasks.filter(exports.isFunction);
        if (filteredTasks.length <= 0)
            cb(null);
        else {
            filteredTasks.forEach(function (task, i) {
                var thunk = task;
                thunk(function (err) {
                    var args = [];
                    for (var _i = 1; _i < arguments.length; _i++) {
                        args[_i - 1] = arguments[_i];
                    }
                    var resultArgs = args;
                    if (err)
                        hasError = true;
                    else {
                        // collect result
                        if (resultArgs.length <= 1)
                            resultArgs = resultArgs[0];
                        ret[i] = resultArgs;
                        successed = successed + 1;
                    }
                    if (exports.isFunction(each))
                        each.call(null, err, resultArgs, i);
                    if (hasError)
                        cb(true);
                    else if (filteredTasks.length === successed) {
                        cb(null, ret);
                    }
                });
            });
        }
    }; };
};
// tasks should be a collection of thunk
exports.series = function () {
    var tasks = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        tasks[_i] = arguments[_i];
    }
    return function (each) { return function (cb) {
        var filteredTasks = tasks.filter(function (val) { return val != null; });
        var nextKey = keyIterator(filteredTasks);
        var nextThunk = function () {
            var key = nextKey.next();
            var thunk = filteredTasks[key];
            if (Array.isArray(thunk))
                thunk = exports.parallel.apply(null, thunk).call(null, each);
            return [+key, thunk]; // convert `key` to number
        };
        var key;
        var thunk;
        var next = nextThunk();
        key = next[0];
        thunk = next[1];
        if (thunk == null)
            return cb(null);
        var ret = [];
        var iterator = function () {
            thunk(function (err) {
                var args = [];
                for (var _i = 1; _i < arguments.length; _i++) {
                    args[_i - 1] = arguments[_i];
                }
                var resultArgs = args;
                if (resultArgs.length <= 1)
                    resultArgs = resultArgs[0];
                if (exports.isFunction(each))
                    each.call(null, err, resultArgs, key);
                if (err)
                    cb(err);
                else {
                    // collect result
                    ret.push(resultArgs);
                    next = nextThunk();
                    key = next[0];
                    thunk = next[1];
                    if (thunk == null)
                        return cb(null, ret); // finished
                    iterator();
                }
            });
        };
        iterator();
    }; };
};
//# sourceMappingURL=utils.js.map